import axios from "@/axios.js"
import CampaignService from "./../campaign_service";
export default {
  searchPurchaseOrders({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/campaigns/purchase_orders/search_purchase_order/" + item)
        .then((response) => {
          commit('SET_AUTOCOMPLETE_DATA', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updatePurchaseOrders({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/purchase_orders/update_purchase_order", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addPurchaseOrders({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/purchase_orders/add_purchase_orders", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllPurchaseOrders({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/purchase_orders/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_STEPS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllPurchaseOrderForGrid({ commit }, item) {
    return new Promise((resolve, reject) => {
      CampaignService.getAllPurchaseOrderForGrid(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchPurchaseOrders(context, purchaseOrderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/purchase_orders/${purchaseOrderId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchPurchaseOrdersList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/purchase_orders_list`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removePurchaseOrder({
    commit
  }, POID) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/purchase_orders/purchase_orders_delete/${POID}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignAssociatedPO(context, purchaseOrderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/purchase_orders/associated_campaign_po/${purchaseOrderId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
